import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../components/Modal/UnDeleteConfirmation";
import { Link } from "react-router-dom";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { checkUserPermission } from "../../../../common/UserPermission";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { toastSuccess } from "../../../../common/Toast";
import { DELETE_MESSAGE } from "../../../../common/Constant";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../../common/CurrencySymbol";
import { AppContext } from "../../../../context/AppContext";

const DeletedItems = (props) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let selectData = [];
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, showTemporaryActivatedItems } = 
    useContext(AppContext);
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedItemsCheckboxIDs, setselectedItemsCheckboxIds] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);

      const selectedItemsCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedItemsCheckboxIds(selectedItemsCheckboxIDs);
    }
  };

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    axios
      .get(
        // api in not made
        `${
          config.itemsBaseUrl
        }/items/managedelete?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [
    perPageSize,
    searchtext,
    sortingId,
    sortingDirection,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  const handleDeletePopup = (id, rows, field, buttonType) => {
    console.log("buttonType", buttonType);
    let itemids;
    let quickbookids;
    if (field === "multipleRowInactive") {
      // datas = rows.map((el) => el.original.ID).join(",");
      const filteredArray = rows.map((index) => data[index]);
      itemids = filteredArray
        .map((el) =>
          el.VariationID > 0 ? el.VariationID + "V" : el.ItemID + "I"
        )
        .join(",");
      quickbookids = filteredArray.map((el) => el.QuickBookId).join(",");
    } else {
      itemids = id;
    }
    const deleteRequestParam = {
      itemids: itemids,
      quickbookids: quickbookids,
      loginuserid: localStorage.getItem("ID"),
      isTemporaryActive: buttonType === "TemporaryActive" ? 1 : 0,
    };

    console.log(deleteRequestParam, "deleteRequestParam");

    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const contextActions = useMemo(() => {
    // const handleDeletePopup = () => {
    //   const deleteRequestParam = {
    //     itemids: selectedItemsCheckboxIDs,
    //   };
    //   localStorage.setItem(
    //     "DeleteRequestParam",
    //     JSON.stringify(deleteRequestParam)
    //   );
    // };
    return (
      <button
        type="button"
        class="btn btn-sm btn-secondary pull-left "
        data-bs-toggle="modal"
        data-bs-target="#UnDeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Un Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  // const columns = [
  //   {
  //     name: "ID",
  //     selector: row => row["ID"],
  //     sortable: true,
  //   },
  //   {
  //     name: "UPC/EAN/ISBN",
  //     selector: row => row["UPC/EAN/ISBN"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Name",
  //     selector: (row) => row.Name,
  //     sortable: true,
  //   },
  //   {
  //     name: "Category Full Path",
  //     selector: row => row["CategoryFullPath"],
  //     sortable: true,
  //   },
  //   checkUserPermission('show-cost-price')&&
  //   {
  //     name: "Cost Price",
  //     selector: row => row["Costprice"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Selling Price",
  //     selector: row => row["Unitprice"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Quantity",
  //     selector: row => row["TotalRecord"],
  //     sortable: true,
  //   },
  //   {
  //     name: "",
  //     selector: row => row["Image"],
  //     sortable: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ItemID",
      Cell: ({ row }) => {
        const { ItemID, VariationID } = row.original;
        return (
          <span>{VariationID > 0 ? `${ItemID}#${VariationID}` : ItemID}</span>
        );
      },
    },

    // {
    //   header: "UPC/EAN/ISBN",
    //   accessorKey: "UPC/EAN/ISBN",
    // },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Category Full Path",
      accessorKey: "Category",
    },
    {
      header: "Cost Price",
      accessorKey: "Costprice",
      Cell: ({ row }) => {
        return checkUserPermission(PERMISSION_SHOW_COST_PRICE) ? (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.Costprice),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        ) : (
          ""
        );
      },
    },
    {
      header: "Selling Price",
      accessorKey: "Unitprice",
      Cell: ({ row }) => parseFloat(row.original.Unitprice).toFixed(2),
      size: 100,
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
      size: 100,
    },
    // {
    //   header: "",
    //   accessorKey:"Image"
    // },
  ]);
  const visibleColumns = columns.filter((columns) => columns.hidden !== false);
  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items List</Link>
                </li>
                <li className="breadcrumb-item active">Deleted Items List</li>
              </ul>
            </div>
          </div>

          <div className="d-flex justify-content-between mb-3">
            {" "}
            <div className="text-center">
              {rowSelectData?.length > 0 && (
                <>
                  <button
                    className="btn btn-dark btn-sm mt-4"
                    onClick={() =>
                      handleDeletePopup(
                        "",
                        rowSelectData,
                        "multipleRowInactive",
                        "Active"
                      )
                    }
                  >
                    Make Active
                  </button>
                  {showTemporaryActivatedItems == "true" && (
                    <button
                      className="btn btn-dark btn-sm mt-4 ms-2"
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          rowSelectData,
                          "multipleRowInactive",
                          "TemporaryActive"
                        )
                      }
                    >
                      Make Temporary Active
                    </button>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="row flex-row-reverse"></div>
          <CommonMatrialReactTable
            MainHeading="Sonar POS"
            ReportHeading="Deleted Items List"
            columns={columns}
            data={data}
            columnGrouping={[]}
            columnsVisibility={{}}
            hodiExport={true}
            enableRowSelection={true}
            // enableRowActions={true}
            isRowSelectionManual={true}
            setRowSelectData={setRowSelection}
            state={{ rowSelection }}
          />

          {/* <MaterialReactTable
            columns={visibleColumns}
            data={data}
            enableColumnResizing
            positionGlobalFilter="left"
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              showGlobalFilter: true ,
              expanded: true, 
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], 
            }}
            muiTableBodyProps={{
              sx: () => ({                    
                '& tr:nth-of-type(even)': {
                   backgroundColor: 'var(--datatable-row-background-color)'
                },
                '& td': {borderRight: '1px solid var(--datatable-row-background-hover-color)',
              lineHeight: '16px',
                fontWeight: '400',
                fontSize:'12px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'},
               
                '& tr': {lineHeight: '16px',
                fontWeight: '400',
                fontSize:'12px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'}
              })
              }}
            muiPaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            muiTableHeadCellProps={{
              sx: theme => ({
                background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                borderRight: '1px solid var(--datatable-row-background-hover-color)',
                lineHeight: '16px',
                fontWeight: '500',
                fontSize:'14px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'
              })
            }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={                
              {
              isError: ()=>({color: 'error',
              children: 'Error loading data'
            }),
              sx: theme => ({
                background: 'var(--datatable-row-background-color)',
                lineHeight: '16px',
                fontWeight: '500',
                fontSize:'14px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'
              })  
            }}
            muiSelectCheckboxProps={{ sx: theme => ({                    
              lineHeight: '16px',
              fontWeight: '400',
              fontSize:'12px',
              color:'var(--prinary-color-800)',
              fontFamily:'Inter'
            })
          }}
          muiSelectAllCheckboxProps={{ sx: theme => ({
           
            lineHeight: '16px',
            fontWeight: '400',
            fontSize:'12px',
            color:'var(--prinary-color-800)',
            fontFamily:'Inter'
          })
        }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              columnFilters,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                 {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) && (
                <Button
                  class="btn btn-sm btn-secondary"
                  size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    onClick={() =>
                      handleDeletePopup(
                        "",
                        table.getSelectedRowModel().rows,
                        "multipleRowInactive"
                      )
                    }
                    variant="contained"
                  >
                    UnDelete
                </Button>
                )}
              </Box>
            )}
          /> */}
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/undeletemutiple`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default DeletedItems;
